module.exports = __webpack_public_path__ + "media/_Award_Wining_Culture.d83299ea.mp4";